module.exports = __webpack_public_path__ + "static/media/Cyera_Logo_Primary.b88c444b.png";